import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameLogic } from '../../../Logic/GameLogic';
import { ButtonController, IButtonControllerOptions } from '../../../Common/ButtonController';
import { GamePadModel } from '../../../Models/Game/GamePadModel';

export interface IGamePadButtonsControllerOptions {
}

export class GamePadButtonsController extends AnimationBaseController {
    $model: GamePadModel;

    public constructor(@Inject private _options: IGamePadButtonsControllerOptions,
                       @Inject private _gameLogic: GameLogic) {
        super('GamePadButtonsController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return {
            childControllers: {
                button: {
                    instanceName: 'button',
                    view: ButtonController,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            this._gameLogic.gamePadButtonA();
                        },
                    },
                },
            },
            modelWatch: {},
        };
    }

    protected onInitialize(): void {
    }

    protected onResize(width: number, height: number, scale: number): void {
        this.y = 0;
        this.x = +width / scale / 2;
    }
}
